<div *ngIf="themeService.loaded | async">
  <div class="ap-themeArea">
    <router-outlet></router-outlet>
  </div>
</div>

<ng-template #themeLoading>
  <div class="ap-spinner-loader">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>
